import {
  UPLOAD_AR_FILE_REQUEST,
  UPLOAD_AR_FILE_SUCCESS,
  UPLOAD_AR_FILE_FAILURE,
  UPLOAD_STOP_GO_PROGRAMS_REQUEST,
  UPLOAD_STOP_GO_PROGRAMS_SUCCESS,
  UPLOAD_STOP_GO_PROGRAMS_FAILURE,
  CLEAR_UPLOAD
} from './uploadActions';
import { serializeDownloadFilterFieldListToFormBuilder } from 'Components/Forms/helpers';

const initialState = {};

const clearUploadData = (state, action) => initialState;

const uploadARFileRequest = (state, action) => ({
  ...state,
  isUploading: true,
  successToast: undefined,
  uploadErrors: undefined,
  uploadSuccess: undefined
});
const uploadARFileSuccess = (state, action) => ({
  ...state,
  isUploading: false,
  uploadErrors: undefined,
  uploadSuccess: { ...action.response?.data }
});
const uploadARFileFailure = (state, action) => ({
  ...state,
  isUploading: false,
  uploadSuccess: undefined,
  uploadErrors: { ...action.error, message: action.error.data?.fileErrorMessage || action.error?.message }
});

const uploadStopGoProgramsRequest = (state, action) => ({
  ...state,
  isLoading: true
});

const uploadStopGoProgramsSuccess = (state, action) => {
  return {
    ...state,
    isLoading: false,
    stopGoFilters: serializeDownloadFilterFieldListToFormBuilder(action.response?.data?.filters) || null,
    uploadErrors: undefined
  };
};
const uploadStopGoProgramsFailure = (state, action) => ({
  ...state,
  isLoading: false,
  uploadErrors: { ...action.error, message: action.error.data?.fileErrorMessage || action.error?.message }
});

export default function uploadFileReducer(state = initialState, action) {
  const handlers = {
    [CLEAR_UPLOAD]: clearUploadData,
    [UPLOAD_AR_FILE_REQUEST]: uploadARFileRequest,
    [UPLOAD_AR_FILE_SUCCESS]: uploadARFileSuccess,
    [UPLOAD_AR_FILE_FAILURE]: uploadARFileFailure,
    [UPLOAD_STOP_GO_PROGRAMS_REQUEST]: uploadStopGoProgramsRequest,
    [UPLOAD_STOP_GO_PROGRAMS_SUCCESS]: uploadStopGoProgramsSuccess,
    [UPLOAD_STOP_GO_PROGRAMS_FAILURE]: uploadStopGoProgramsFailure
  };
  if (handlers.hasOwnProperty(action.type)) {
    return handlers[action.type](state, action);
  } else {
    return state;
  }
}
